import { createSelector } from 'reselect';

import * as SimstreamConstants from './constants';

export function getStreamViolationData(state) {
  return state.simstream.getIn([SimstreamConstants.ReducerKeys.STREAM_VIOLATION_DATA], null);
}

export function getStreamViolationErrorData(state) {
  return state.simstream.getIn(
    [
      SimstreamConstants.ReducerKeys.STREAM_VIOLATION_DATA,
      SimstreamConstants.ReducerKeys.ERROR_DATA,
    ],
    null,
  );
}

export const isStreamViolationStale = createSelector(
  getStreamViolationData,
  streamViolationData => {
    return streamViolationData && streamViolationData.get(SimstreamConstants.ReducerKeys.IS_STALE);
  },
);

export const isStreamViolationErrorValid = state => {
  const streamViolationErrorData = getStreamViolationErrorData(state);
  if (!streamViolationErrorData) {
    return false;
  }
  // if the stream violation is still valid
  const expiresMs =
    (streamViolationErrorData.get('expiresSeconds') ||
      SimstreamConstants.StreamViolationDefaults.EXPIRES_IN) * 1000;
  const errorTimeStamp = streamViolationErrorData.get('errorTimeStamp');
  if (errorTimeStamp && Date.now() < new Date(new Date(errorTimeStamp).getTime() + expiresMs)) {
    return true;
  }

  return false;
};

export function isStreamViolationValidAndNotStale(state) {
  return isStreamViolationErrorValid(state) && !isStreamViolationStale(state);
}

export default {
  getStreamViolationData,
  getStreamViolationErrorData,
  isStreamViolationStale,
  isStreamViolationErrorValid,
  isStreamViolationValidAndNotStale,
};
